export { default as EditIcon } from "@/icons/fontawesome/regular/pen-to-square.svg";
export { default as FolderGearIcon } from "@/icons/fontawesome/regular/folder-gear.svg";
export { default as LayersIcon } from "@/icons/fontawesome/regular/layer-group.svg";
export { default as PaletteIcon } from "@/icons/fontawesome/regular/palette.svg";
export { default as PlusIcon } from "@/icons/fontawesome/regular/plus.svg";
export { default as MinusIcon } from "@/icons/fontawesome/regular/minus.svg";
export { default as CloseIcon } from "@/icons/fontawesome/regular/xmark.svg";
export { default as TrashIcon } from "@/icons/fontawesome/regular/trash-can.svg";
export { default as RecycleIcon } from "@/icons/fontawesome/regular/recycle.svg";
export { default as UndoIcon } from "@/icons/fontawesome/regular/arrow-rotate-left.svg";
export { default as RedoIcon } from "@/icons/fontawesome/regular/arrow-rotate-right.svg";
export { default as BrowserIcon } from "@/icons/fontawesome/regular/browser.svg";
export { default as HistoryIcon } from "@/icons/fontawesome/regular/clock-rotate-left.svg";
export { default as CogsIcon } from "@/icons/fontawesome/regular/gears.svg";
export { default as DesktopIcon } from "@/icons/fontawesome/regular/display.svg";
export { default as GearIcon } from "@/icons/fontawesome/regular/gear.svg";
export { default as ExpandIcon } from "@/icons/fontawesome/regular/arrow-up-right-and-arrow-down-left-from-center.svg";
export { default as MinifyGlassIcon } from "@/icons/fontawesome/regular/magnifying-glass-minus.svg";
export { default as MagnifyingGlassIcon } from "@/icons/fontawesome/regular/magnifying-glass-plus.svg";
export { default as DuplicateIcon } from "@/icons/fontawesome/regular/clone.svg";
export { default as MobileIcon } from "@/icons/fontawesome/regular/mobile-button.svg";
export { default as PenIcon } from "@/icons/fontawesome/regular/pen.svg";
export { default as StarIcon } from "@/icons/fontawesome/regular/star.svg";
export { default as TabletIcon } from "@/icons/fontawesome/regular/tablet-button.svg";
export { default as ElementStudioIcon } from "@/icons/fontawesome/regular/wand-magic-sparkles.svg";
export { default as WordPressIcon } from "@/icons/fontawesome/brands/wordpress-simple.svg";
export { default as WrenchIcon } from "@/icons/fontawesome/regular/wrench.svg";
export { default as WrenchSimpleIcon } from "@/icons/fontawesome/regular/wrench-simple.svg";
export { default as CaretDownIcon } from "@/icons/fontawesome/regular/caret-down.svg";
export { default as SlidersIcon } from "@/icons/fontawesome/regular/sliders.svg";
export { default as BreakpointsIcon } from "@/icons/fontawesome/regular/laptop-mobile.svg";
export { default as FontIcon } from "@/icons/fontawesome/regular/font.svg";
export { default as BreakdanceIcon } from "@/icons/fontawesome/regular/breakdance.svg";
export { default as SquareIcon } from "@/icons/fontawesome/regular/square.svg";
export { default as ActionsIcon } from "@/icons/fontawesome/regular/arrow-right-arrow-left.svg";
export { default as BarsIcon } from "@/icons/fontawesome/regular/bars.svg";
export { default as BoxIcon } from "@/icons/fontawesome/regular/box.svg";
export { default as CodeIcon } from "@/icons/fontawesome/regular/code.svg";
export { default as CssIcon } from "@/icons/fontawesome/brands/css3.svg";
export { default as Css3Icon } from "@/icons/fontawesome/brands/css3-alt.svg";
export { default as AttributesIcon } from "@/icons/fontawesome/regular/dice-d6.svg";
export { default as Html5Icon } from "@/icons/fontawesome/brands/html5.svg";
export { default as CheckListIcon } from "@/icons/fontawesome/regular/list-check.svg";
export { default as TextIcon } from "@/icons/fontawesome/regular/text.svg";
export { default as ChevronDownIcon } from "@/icons/fontawesome/regular/chevron-down.svg";
export { default as GripVerticalIcon } from "@/icons/fontawesome/regular/grip-vertical.svg";
export { default as GripLinesIcon } from "@/icons/fontawesome/regular/grip-lines.svg";

export { default as SearchFileIcon } from "@/icons/fontawesome/regular/file-magnifying-glass.svg";
export { default as ColorPickerIcon } from "@/icons/fontawesome/regular/eye-dropper.svg";
export { default as ConditionsIcon } from "@/icons/fontawesome/regular/split.svg";
export { default as DatabaseIcon } from "@/icons/fontawesome/regular/database.svg";
export { default as CloseCircleIcon } from "@/icons/fontawesome/regular/circle-xmark.svg";
export { default as OpenFolderIcon } from "@/icons/fontawesome/regular/folder-open.svg";
export { default as AddFileIcon } from "@/icons/fontawesome/regular/file-plus.svg";
export { default as SaveIcon } from "@/icons/fontawesome/regular/floppy-disk.svg";
export { default as TableColumnIcon } from "@/icons/fontawesome/regular/table-columns.svg";
export { default as CloseSquareIcon } from "@/icons/fontawesome/regular/square-xmark.svg";
export { default as ExternalLinkIcon } from "@/icons/fontawesome/regular/arrow-up-right-from-square.svg";
export { default as ArrowUpToLine } from "@/icons/fontawesome/regular/arrow-up-to-line.svg";
export { default as ArrowDownToLine } from "@/icons/fontawesome/regular/arrow-down-to-line.svg";
export { default as RotateIcon } from "@/icons/fontawesome/regular/rotate.svg";
export { default as EyeSolidIcon } from "@/icons/fontawesome/regular/eye.svg";
export { default as EyeSlashSolidIcon } from "@/icons/fontawesome/regular/eye-slash.svg";
export { default as EllipsisIcon } from "@/icons/fontawesome/regular/ellipsis.svg";
export { default as EllipsisVerticalIcon } from "@/icons/fontawesome/regular/ellipsis-vertical.svg";
export { default as EllipsisStrokeVerticalIcon } from "@/icons/fontawesome/regular/ellipsis-stroke-vertical.svg";
export { default as EllipsisStrokeIcon } from "@/icons/fontawesome/regular/ellipsis-stroke.svg";
export { default as BracketsIcon } from "@/icons/fontawesome/regular/brackets-curly.svg";
export { default as UploadFileIcon } from "@/icons/fontawesome/regular/file-arrow-up.svg";
export { default as DownloadFileIcon } from "@/icons/fontawesome/regular/file-arrow-down.svg";
export { default as SpinnerIcon } from "@/icons/fontawesome/regular/spinner.svg";
export { default as HoverIcon } from "@/icons/fontawesome/regular/hand-pointer.svg";
export { default as SearchIcon } from "@/icons/fontawesome/regular/magnifying-glass.svg";
export { default as LinkIcon } from "@/icons/fontawesome/regular/link.svg";
export { default as ClipboardIcon } from "@/icons/fontawesome/regular/clipboard.svg";
export { default as CheckIcon } from "@/icons/fontawesome/regular/check.svg";
export { default as ExclamationMarkCircleIcon } from "@/icons/fontawesome/regular/circle-exclamation.svg";
export { default as StrikethroughIcon } from "@/icons/fontawesome/regular/strikethrough.svg";
export { default as OverlineIcon } from "@/icons/fontawesome/regular/overline.svg";
export { default as UnderlineIcon } from "@/icons/fontawesome/regular/underline.svg";
export { default as ItalicIcon } from "@/icons/fontawesome/regular/italic.svg";
export { default as VideoIcon } from "@/icons/fontawesome/regular/video.svg";
export { default as ImageIcon } from "@/icons/fontawesome/regular/image.svg";
export { default as BorderBottomIcon } from "@/icons/fontawesome/regular/border-bottom.svg";
export { default as ImageAndVideIcon } from "@/icons/fontawesome/regular/photo-film.svg";
export { default as ListIcon } from "@/icons/fontawesome/regular/list-ul.svg";
export { default as BoldIcon } from "@/icons/fontawesome/regular/bold.svg";
export { default as H6Icon } from "@/icons/fontawesome/regular/h6.svg";
export { default as H5Icon } from "@/icons/fontawesome/regular/h5.svg";
export { default as H4Icon } from "@/icons/fontawesome/regular/h4.svg";
export { default as H3Icon } from "@/icons/fontawesome/regular/h3.svg";
export { default as H2Icon } from "@/icons/fontawesome/regular/h2.svg";
export { default as H1Icon } from "@/icons/fontawesome/regular/h1.svg";
export { default as HeadingIcon } from "@/icons/fontawesome/regular/heading.svg";
export { default as OlListIcon } from "@/icons/fontawesome/regular/list-ol.svg";

export { default as AlignJustifyIcon } from "@/icons/fontawesome/regular/align-justify.svg";
export { default as DistributeSpacingHorizontalIcon } from "@/icons/fontawesome/regular/distribute-spacing-horizontal.svg";
export { default as FlexAlignBottomIcon } from "@/icons/fontawesome/regular/objects-align-bottom.svg";
export { default as FlexAlignCenterVerticalIcon } from "@/icons/fontawesome/regular/objects-align-center-vertical.svg";
export { default as FlexAlignTopIcon } from "@/icons/fontawesome/regular/objects-align-top.svg";
export { default as FlexAlignLeftIcon } from "@/icons/fontawesome/regular/objects-align-left.svg";
export { default as FlexAlignCenterHorizontalIcon } from "@/icons/fontawesome/regular/objects-align-center-horizontal.svg";
export { default as FlexAlignRightIcon } from "@/icons/fontawesome/regular/objects-align-right.svg";
export { default as AlignCenterIcon } from "@/icons/fontawesome/regular/align-center.svg";
export { default as AlignRightIcon } from "@/icons/fontawesome/regular/align-right.svg";
export { default as AlignLeftIcon } from "@/icons/fontawesome/regular/align-left.svg";
export { default as LeftAndRightArrowsIcon } from "@/icons/fontawesome/regular/arrows-left-right.svg";
export { default as CheckSquareIcon } from "@/icons/fontawesome/regular/square-check.svg";
export { default as MinimizeIcon } from "@/icons/fontawesome/regular/minimize.svg";
export { default as UpAndDownArrowsIcon } from "@/icons/fontawesome/regular/arrows-up-down.svg";
export { default as ArrowUpIcon } from "@/icons/fontawesome/regular/arrow-up.svg";
export { default as ArrowDownIcon } from "@/icons/fontawesome/regular/arrow-down.svg";
export { default as ArrowRightIcon } from "@/icons/fontawesome/regular/arrow-right.svg";
export { default as ArrowLeftIcon } from "@/icons/fontawesome/regular/arrow-left.svg";
export { default as CircleIcon } from "@/icons/fontawesome/regular/circle.svg";
export { default as BorderCenterIcon } from "@/icons/fontawesome/regular/border-center-h.svg";
export { default as BorderTopIcon } from "@/icons/fontawesome/regular/border-top.svg";
export { default as IconsIcon } from "@/icons/fontawesome/regular/icons.svg";
export { default as BanIcon } from "@/icons/fontawesome/regular/ban.svg";
export { default as DollarIcon } from "@/icons/fontawesome/regular/dollar-sign.svg";
export { default as MaximizeIcon } from "@/icons/fontawesome/regular/arrows-maximize.svg";
export { default as LightingIcon } from "@/icons/fontawesome/regular/bolt-lightning.svg";
export { default as GrinHeartsIcon } from "@/icons/fontawesome/regular/face-grin-hearts.svg";
export { default as HeartIcon } from "@/icons/fontawesome/regular/heart.svg";
export { default as SlidersSimpleIcon } from "@/icons/fontawesome/regular/sliders-simple.svg";
export { default as BorderRadiusAllIcon } from "@/icons/fontawesome/regular/border-radius-all.svg";
export { default as BorderRadiusAllCustomIcon } from "@/icons/fontawesome/regular/border-radius-all-custom.svg";
export { default as BorderRadiusTopLeftIcon } from "@/icons/fontawesome/regular/border-radius-top-left.svg";
export { default as BorderRadiusTopRightIcon } from "@/icons/fontawesome/regular/border-radius-top-right.svg";
export { default as BorderRadiusBottomRightIcon } from "@/icons/fontawesome/regular/border-radius-bottom-right.svg";
export { default as BorderRadiusBottomLeftIcon } from "@/icons/fontawesome/regular/border-radius-bottom-left.svg";
export { default as SquareAltIcon } from "@/icons/fontawesome/regular/square-alt.svg";
export { default as BorderTopAltIcon } from "@/icons/fontawesome/regular/border-top-alt.svg";
export { default as BorderRightAltIcon } from "@/icons/fontawesome/regular/border-right-alt.svg";
export { default as BorderBottomAltIcon } from "@/icons/fontawesome/regular/border-bottom-alt.svg";
export { default as BorderLeftAltIcon } from "@/icons/fontawesome/regular/border-left-alt.svg";
export { default as CodeBranchIcon } from "@/icons/fontawesome/regular/code-branch.svg";
export { default as CopyIcon } from "@/icons/fontawesome/regular/copy.svg";
export { default as CircleInfoIcon } from "@/icons/fontawesome/regular/circle-info.svg";
export { default as ArrowLeftLongIcon } from "@/icons/fontawesome/regular/arrow-left-long.svg";
export { default as GlobeIcon } from "@/icons/fontawesome/regular/globe.svg";
export { default as CartShoppingIcon } from "@/icons/fontawesome/regular/cart-shopping.svg";
export { default as TagsIcon } from "@/icons/fontawesome/regular/tags.svg";
export { default as FilterListIcon } from "@/icons/fontawesome/regular/filter-list.svg";
export { default as ObjectsAlignBottom } from "@/icons/fontawesome/regular/objects-align-bottom.svg";
export { default as ObjectsAlignCenterVertical } from "@/icons/fontawesome/regular/objects-align-center-vertical.svg";
export { default as ObjectsAlignTop } from "@/icons/fontawesome/regular/objects-align-top.svg";
export { default as ObjectsAlignLeft } from "@/icons/fontawesome/regular/objects-align-left.svg";
export { default as ObjectsAlignCenterHorizontal } from "@/icons/fontawesome/regular/objects-align-center-horizontal.svg";
export { default as ObjectsAlignRight } from "@/icons/fontawesome/regular/objects-align-right.svg";
export { default as UpRightAndDownLeftFromCenter } from "@/icons/fontawesome/regular/up-right-and-down-left-from-center.svg";
export { default as DownLeftAndUpRightToCenter } from "@/icons/fontawesome/regular/down-left-and-up-right-to-center.svg";
export { default as HouseIcon } from "@/icons/fontawesome/regular/house.svg";
export { default as Grid2Icon } from "@/icons/fontawesome/regular/grid-2.svg";
export { default as FolderIcon } from "@/icons/fontawesome/regular/folder.svg";
export { default as FolderOpenIcon } from "@/icons/fontawesome/regular/folder-open.svg";
export { default as RectangleWideIcon } from "@/icons/fontawesome/regular/rectangle-wide.svg";
export { default as RectangleVerticalIcon } from "@/icons/fontawesome/regular/rectangle-vertical.svg";
export { default as FileLinesIcon } from "@/icons/fontawesome/regular/file-lines.svg";
export { default as Columns3Icon } from "@/icons/fontawesome/regular/columns-3.svg";
export { default as LinkSimpleIcon } from "@/icons/fontawesome/regular/link-simple.svg";
export { default as SquareUpRightIcon } from "@/icons/fontawesome/regular/square-up-right.svg";
export { default as SquareQuestionIcon } from "@/icons/fontawesome/regular/square-question.svg";
export { default as SquareQuoteIcon } from "@/icons/fontawesome/regular/square-quote.svg";
export { default as LeftRightIcon } from "@/icons/fontawesome/regular/left-right.svg";
export { default as TimerIcon } from "@/icons/fontawesome/regular/timer.svg";
export { default as HourglassIcon } from "@/icons/fontawesome/regular/hourglass.svg";
export { default as FacebookSquareIcon } from "@/icons/fontawesome/brands/facebook-square.svg";

export { default as QuotesIcon } from "@/icons/fontawesome/regular/quotes.svg";
export { default as ImagePolaroidIcon } from "@/icons/fontawesome/regular/image-polaroid.svg";
export { default as TimelineIcon } from "@/icons/fontawesome/regular/timeline.svg";
export { default as ThumbsUpIcon } from "@/icons/fontawesome/regular/thumbs-up.svg";
export { default as ShareFromSquareIcon } from "@/icons/fontawesome/regular/share-from-square.svg";
export { default as UserIcon } from "@/icons/fontawesome/regular/user.svg";
export { default as CommentsIcon } from "@/icons/fontawesome/regular/comments.svg";

export { default as BoxOpenIcon } from "@/icons/fontawesome/regular/box-open.svg";
export { default as StarHalfIcon } from "@/icons/fontawesome/regular/star-half-stroke.svg";
export { default as CreditCardIcon } from "@/icons/fontawesome/regular/credit-card.svg";
export { default as CartPlusIcon } from "@/icons/fontawesome/regular/cart-plus.svg";
export { default as TruckIcon } from "@/icons/fontawesome/regular/truck.svg";
export { default as ChevronsRightIcon } from "@/icons/fontawesome/regular/chevrons-right.svg";

export { default as List2Icon } from "@/icons/fontawesome/regular/list.svg";
export { default as GridIcon } from "@/icons/fontawesome/regular/grid.svg";
export { default as ShopIcon } from "@/icons/fontawesome/regular/shop.svg";
export { default as SquarePollHorizontalIcon } from "@/icons/fontawesome/regular/square-poll-horizontal.svg";

export { default as StarsIcon } from "@/icons/fontawesome/regular/stars.svg";

// IMPORTANT this must contain the exact name the icon is exported as
export const iconNames = [
  "List2Icon",
  "GridIcon",
  "ShopIcon",
  "SquarePollHorizontalIcon",

  "BoxOpenIcon",
  "StarHalfIcon",
  "CreditCardIcon",
  "CartPlusIcon",
  "TruckIcon",
  "ChevronsRightIcon",

  "CommentsIcon",
  "QuotesIcon",
  "ImagePolaroidIcon",
  "TimelineIcon",
  "ThumbsUpIcon",
  "ShareFromSquareIcon",
  "UserIcon",

  "RectangleWideIcon",
  "RectangleVerticalIcon",
  "FileLinesIcon",
  "Columns3Icon",
  "LinkSimpleIcon",
  "SquareUpRightIcon",
  "SquareQuestionIcon",
  "SquareQuoteIcon",
  "LeftRightIcon",
  "TimerIcon",
  "HourglassIcon",
  "FacebookSquareIcon",

  "SlidersSimpleIcon",
  "EditIcon",
  "LayersIcon",
  "PaletteIcon",
  "PlusIcon",
  "MinusIcon",
  "CloseIcon",
  "TrashIcon",
  "RecycleIcon",
  "UndoIcon",
  "RedoIcon",
  "BrowserIcon",
  "HistoryIcon",
  "CogsIcon",
  "DesktopIcon",
  "GearIcon",
  "ExpandIcon",
  "MinifyGlassIcon",
  "MagnifyingGlassIcon",
  "DuplicateIcon",
  "MobileIcon",
  "PenIcon",
  "StarIcon",
  "TabletIcon",
  "ElementStudioIcon",
  "WordPressIcon",
  "WrenchIcon",
  "WrenchSimpleIcon",
  "CaretDownIcon",
  "SlidersIcon",
  "BreakpointsIcon",
  "FontIcon",
  "BreakdanceIcon",
  "SquareIcon",
  "ActionsIcon",
  "BarsIcon",
  "BoxIcon",
  "CodeIcon",
  "CssIcon",
  "Css3Icon",
  "AttributesIcon",
  "Html5Icon",
  "CheckListIcon",
  "TextIcon",
  "ChevronDownIcon",
  "GripVerticalIcon",
  "GripLinesIcon",
  "SearchFileIcon",
  "ColorPickerIcon",
  "ConditionsIcon",
  "DatabaseIcon",
  "CloseCircleIcon",
  "OpenFolderIcon",
  "SaveIcon",
  "AddFileIcon",
  "TableColumnIcon",
  "CloseSquareIcon",
  "ExternalLinkIcon",
  "RotateIcon",
  "EyeSolidIcon",
  "EllipsisIcon",
  "EllipsisStrokeVerticalIcon",
  "EllipsisStrokeIcon",
  "BracketsIcon",
  "UploadFileIcon",
  "DownloadFileIcon",
  "SpinnerIcon",
  "HoverIcon",
  "SearchIcon",
  "LinkIcon",
  "ClipboardIcon",
  "CheckIcon",
  "ExclamationMarkCircleIcon",
  "StrikethroughIcon",
  "OverlineIcon",
  "UnderlineIcon",
  "ItalicIcon",
  "VideoIcon",
  "ImageIcon",
  "BorderBottomIcon",
  "ImageAndVideIcon",
  "ListIcon",
  "BoldIcon",
  "H6Icon",
  "H5Icon",
  "H4Icon",
  "H3Icon",
  "H2Icon",
  "H1Icon",
  "HeadingIcon",
  "OlListIcon",
  "DistributeSpacingHorizontalIcon",
  "FlexAlignCenterHorizontalIcon",
  "FlexAlignCenterVerticalIcon",
  "FlexAlignBottomIcon",
  "AlignJustifyIcon",
  "AlignCenterIcon",
  "AlignRightIcon",
  "AlignLeftIcon",
  "LeftAndRightArrowsIcon",
  "CheckSquareIcon",
  "MinimizeIcon",
  "UpAndDownArrowsIcon",
  "FlexAlignTopIcon",
  "FlexAlignLeftIcon",
  "FlexAlignRightIcon",
  "EllipsisVerticalIcon",
  "ArrowUpIcon",
  "ArrowDownIcon",
  "ArrowRightIcon",
  "ArrowLeftIcon",
  "CircleIcon",
  "BorderCenterIcon",
  "BorderTopIcon",
  "IconsIcon",
  "BanIcon",
  "DollarIcon",
  "MaximizeIcon",
  "LightingIcon",
  "GrinHeartsIcon",
  "HeartIcon",
  "EyeSlashSolidIcon",
  "BorderRadiusAllIcon",
  "BorderRadiusAllCustomIcon",
  "BorderRadiusTopLeftIcon",
  "BorderRadiusTopRightIcon",
  "BorderRadiusBottomRightIcon",
  "BorderRadiusBottomLeftIcon",
  "SquareAltIcon",
  "BorderTopAlt",
  "BorderRightAlt",
  "BorderBottomAlt",
  "BorderLeftAlt",
  "FolderGearIcon",
  "CodeBranchIcon",
  "CopyIcon",
  "CircleInfoIcon",
  "ArrowLeftLongIcon",
  "GlobeIcon",
  "CartShoppingIcon",
  "TagsIcon",
  "FilterListIcon",
  "UpRightAndDownLeftFromCenter",
  "DownLeftAndUpRightToCenter",
  "HouseIcon",
  "Grid2Icon",
  "FolderIcon",
  "FolderOpenIcon",
  "StarsIcon"
] as const;

export type IconName = typeof iconNames[number];
